import { ICarePlan } from './icare-plan';
export interface ICarePlanCategory {
    codeCategoryIdentifier: string;
    categoryDisplay: string;
    Definition: string;
    tenantId: number;
    language: string;
    carePlan: ICarePlan[];
}